import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService } from '../../../tms-shared';
import { SalesOrderDeposit, SalesOrderDepositDetails } from '../../models';
import { TmsWebBaseEditCreateService } from '../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderDepositService extends TmsWebBaseEditCreateService<SalesOrderDeposit, SalesOrderDepositDetails> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SalesOrderDeposit', $localize`Sales Order Deposit`, httpService, notificationService);
  }

  getForSalesOrderHeader(id: string): Observable<SalesOrderDeposit[]> {
    return this.httpService.get<SalesOrderDeposit[]>(`${this.apiUrl}/SalesOrderHeader?id=${id}`);
  }

  getForSalesInvoiceHeader(ids: string[]): Observable<SalesOrderDeposit[]> {
    return this.httpService.post<SalesOrderDeposit[]>(`${this.apiUrl}/SalesInvoiceHeader`, { ids });
  }

  getSalesOrderPayDeposit(includePaid: boolean): Observable<SalesOrderDeposit[]> {
    return this.httpService.get<SalesOrderDeposit[]>(`${this.apiUrl}/SalesOrderPayDeposits?includePaid=${includePaid}`);
  }

  updateDepositToInvoice(salesOrderDepositId: string, salesInvoiceHeaderId: string, selected: boolean) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateDepositToInvoice`, {
      salesOrderDepositId,
      salesInvoiceHeaderId,
      selected,
    });
  }

  paySalesOrderDeposits(ids: string[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/PayDeposits`, { ids });
  }

  unpaySalesOrderDeposits(ids: string[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/UnpayDeposits`, { ids });
  }
}
